// extracted by mini-css-extract-plugin
export default {"footer-wrapper":"Footer_footer-wrapper__wzFoK","banner":"Footer_banner__6EXLP","banner-text":"Footer_banner-text__hymqr"};